import { useTranslations } from '@vocab/react';
import { Text, Heading, Stack, Box } from 'braid-design-system';

import translations from './.vocab';
import { Tools } from './Tools';

export const SomethingWentWrong = () => {
  const { t } = useTranslations(translations);

  return (
    <Box
      textAlign="center"
      padding={{
        mobile: 'none',
        tablet: 'large',
        desktop: 'large',
        wide: 'large',
      }}
      marginTop="large"
      marginBottom="large"
    >
      <Stack space="large" align="center">
        <Tools />
        <Stack space="small">
          <Heading level="4">{t("We're working on it.")}</Heading>
          <Text>{t("We're fixing this as fast as we can.")}</Text>
          <Text>{t('Try refreshing the page or check back later.')}</Text>
        </Stack>
      </Stack>
    </Box>
  );
};
